import BaseDatepicker from 'components/atoms/base-datepicker';
import { DateFormatter } from 'infrastructure/functions';
import { DateFormats } from 'infrastructure/enums';
import PropTypes from 'prop-types';
import { parse, isValid } from 'date-fns';

const KNOWN_DATE_FORMATS = [
  DateFormats['MM/dd/yyyy'],
  DateFormats['MM-dd-yyyy'],
];

const parseFlexibleDate = (val) => {
  if (!val) return val;
  if (val instanceof Date) return val;
  for (const fmt of KNOWN_DATE_FORMATS) {
    const d = parse(val, fmt, new Date());
    if (isValid(d)) return d;
  }
  const d = new Date(val);
  if (isValid(d)) return d;
  return val;
};

const DateInput = ({
  id,
  title,
  setValue,
  values,
  isRequired,
  requiredIf,
  helpText,
}) => {
  let required = isRequired;
  if (requiredIf) {
    required = isRequired || values[requiredIf.key] === requiredIf.value;
  }
  return (
    <div className="input-wrapper" data-cy={id}>
      <label htmlFor={id}>
        {title} {required && <span className="color-red">*</span>}
      </label>
      {helpText && <p className="help-text">{helpText}</p>}
      <BaseDatepicker
        format={DateFormats['MM/dd/yyyy']}
        onChange={(date) => {
          setValue({
            [id]: DateFormatter({ date, format: DateFormats['MM/dd/yyyy'] }),
          });
        }}
        value={parseFlexibleDate(values[id])}
      />
    </div>
  );
};

DateInput.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string,
  helpText: PropTypes.string,
  setValue: PropTypes.func,
  isRequired: PropTypes.bool,
  requiredIf: PropTypes.object,
  values: PropTypes.shape(),
};

export default DateInput;
